import { render, staticRenderFns } from "./weixinShipOrder.vue?vue&type=template&id=177997a2&"
import script from "./weixinShipOrder.vue?vue&type=script&lang=js&"
export * from "./weixinShipOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports